// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O2Z7j","question":"styles_question__lfZy1","inputVisibleButton":"styles_inputVisibleButton__3o3zL","note":"styles_note__1A55J"};